import * as React from 'react';

import { IOfferGeo } from '../../../types/offer';

export const useLocationId = (geo?: IOfferGeo) => {
  const locationId = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }

    return (geo.address.length > 0 && geo.address[0].id) || undefined;
  }, [geo]);

  return locationId;
};
